import { attr, belongsTo } from 'spraypaint'
import ApplicationRecord from './ApplicationRecord'

const PageOption = ApplicationRecord.extend({
  static: {
    jsonapiType: 'page_options',
  },
  attrs: {
    name: attr(),
    pageOptionTypeId: attr(),
    description: attr(),
    pageOptionType: belongsTo(),
  },
})

export default PageOption
